import { Grid } from '@material-ui/core'
import { Fragment } from 'react'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  PinterestIcon,
  PinterestShareButton,
  RedditIcon,
  RedditShareButton,
  TelegramIcon,
  TelegramShareButton,
  TumblrIcon,
  TumblrShareButton,
  TwitterIcon,
  TwitterShareButton,
  ViberIcon,
  ViberShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share'
import { pictureUrl } from '../../components/common/pictureUrl'

const SharingLinks = ({ url, label, logo }) => (
  <Fragment>
    <Grid container spacing={2} alignItems="center">
      <Grid item>
        <EmailShareButton url={url} subject={label}>
          <EmailIcon size={45} round />
        </EmailShareButton>
      </Grid>
      <Grid item>
        <FacebookShareButton url={url} quote={label} hashtag="recrutement">
          <FacebookIcon size={45} round />
        </FacebookShareButton>
      </Grid>
      <Grid item>
        <LinkedinShareButton url={url} title={label} source="TrustMe.work">
          <LinkedinIcon size={45} round />
        </LinkedinShareButton>
      </Grid>
      <Grid item>
        <PinterestShareButton url={url} description={label} media={pictureUrl(logo, 200, 200)}>
          <PinterestIcon size={45} round />
        </PinterestShareButton>
      </Grid>
      <Grid item>
        <RedditShareButton url={url} title={label}>
          <RedditIcon size={45} round />
        </RedditShareButton>
      </Grid>
      <Grid item>
        <TelegramShareButton url={url} title={label}>
          <TelegramIcon size={45} round />
        </TelegramShareButton>
      </Grid>
      <Grid item>
        <TumblrShareButton url={url} title={label}>
          <TumblrIcon size={45} round />
        </TumblrShareButton>
      </Grid>
      <Grid item>
        <TwitterShareButton url={url} title={label} hashtags={['TrustMe', 'Hiring']}>
          <TwitterIcon size={45} round />
        </TwitterShareButton>
      </Grid>
      <Grid item>
        <ViberShareButton url={url} title={label}>
          <ViberIcon size={45} round />
        </ViberShareButton>
      </Grid>
      <Grid item>
        <WhatsappShareButton url={url} title={label}>
          <WhatsappIcon size={45} round />
        </WhatsappShareButton>
      </Grid>
    </Grid>
  </Fragment>
)

export default SharingLinks
